import { NetworkType } from './beacon/NetworkType';
//# sourceMappingURL=ui.js.map